/**
 * Cross-sprint navigation handlers.
 */

const LOG_PREFIX = '[useCrossSprintActions]';

/**
 * Creates the focus task in flowchart handler.
 * If task is in current sprint, just focus it.
 * If task is in a nested sprint, navigate to that sprint first.
 */
export const createFocusTaskHandler = ({
  findSprintForTask,
  setCurrentView,
  flowchartRef,
  onSelectSprint,
}) => (taskId) => {
  const { sprint: targetSprint, isCurrentSprint } = findSprintForTask(taskId);

  if (!targetSprint) {
    console.warn(`${LOG_PREFIX} handleCrossSprintFocusTask: Task not found in any sprint:`, taskId);
    return;
  }

  if (isCurrentSprint) {
    setCurrentView?.('flow');
    setTimeout(() => flowchartRef?.current?.focusTask(taskId), 100);
  } else {
    // Navigate to nested sprint with view & missionId options
    onSelectSprint?.(targetSprint, { view: 'flow', missionId: taskId });
  }
};
